// TODO: após clonar o skeleton, ajustar os links de ambientes

const dev = {
	API_ENDPOINT_URL: "http://localhost:8080/test-it/api",
	PUBLIC_PREFIX_PATH: "",
	API_SOCKET_ENDPOINT_URL: "http://localhost:8080",
	API_SOCKET_SUFIX_PATH: "/teste/socket.io",
	API_SOCKET_DASHBOARD_SUFIX_PATH: "/dashboard/socket.io",
};

const prod = {
	API_ENDPOINT_URL:
		"https://test-it-back-97tvq.ondigitalocean.app/test-it-back2/test-it/api",
	PUBLIC_PREFIX_PATH: "",
	API_SOCKET_ENDPOINT_URL: "https://test-it-back-97tvq.ondigitalocean.app",
	API_SOCKET_SUFIX_PATH: "/test-it-back2/test-it/teste/socket.io",
	API_SOCKET_DASHBOARD_SUFIX_PATH:
		"/test-it-back2/test-it/dashboard/socket.io",
};

const test = {
	API_ENDPOINT_URL: "https://homolog.dimo.com.br/test-it-back/api",
	PUBLIC_PREFIX_PATH: "/test-it",
	API_SOCKET_ENDPOINT_URL: "https://homolog.dimo.com.br",
	API_SOCKET_SUFIX_PATH: "/test-it-back/teste/socket.io",
	API_SOCKET_DASHBOARD_SUFIX_PATH: "/test-it-back/dashboard/socket.io",
};

const getEnv = () => {
	switch (process.env.REACT_APP_ENV) {
		case "development":
			return dev;
		case "production":
			return prod;
		case "test":
			return test;
		default:
			return dev;
	}
};

export const env = getEnv();
